import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'tipo-documento';
const route = {
  tipoDocumentoList: `${baseRef}/combo`,
};

@Injectable({
  providedIn: 'root'
})
export class TipoDocumentoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar() {
    return this.domainCache.getOrLoad(route.tipoDocumentoList, () =>
      this.apiService.get<any[]>(`${route.tipoDocumentoList}`, undefined, undefined, true)
    );
  }
}
